import React from 'react';
import { cn } from '@/lib/utils';

function GridRow({ children, className, ...props }: React.ComponentProps<'div'>): React.JSX.Element {
    return (
        <div className={cn('grid grid-cols-12 gap-3', className)} {...props}>
            {children}
        </div>
    );
}

export default GridRow;
